import React, { createContext, useContext, ReactNode } from 'react';
import { ICustomUrls } from '@/lib/contentstack-sdk/types';

interface GlobalLinksContextType {
  globalLinks: ICustomUrls[];
}

const GlobalLinksContext = createContext<GlobalLinksContextType | undefined>(
  undefined,
);

export const useGlobalLinks = (): GlobalLinksContextType => {
  const context = useContext(GlobalLinksContext);
  if (!context) {
    throw new Error('useGlobalLinks must be used within a GlobalLinksProvider');
  }
  return context;
};

interface GlobalLinksProviderProps {
  children: ReactNode;
  globalLinks: ICustomUrls[];
}

export const GlobalLinksProvider = ({
  children,
  globalLinks,
}: GlobalLinksProviderProps) => {
  return (
    <GlobalLinksContext.Provider value={{ globalLinks }}>
      {children}
    </GlobalLinksContext.Provider>
  );
};
